import { UserContentSummaryModel } from '@/domain/models/content/user-content-summary-model'

export interface UserContentSummary {
  get(): Promise<UserContentSummary.Model>
}

export namespace UserContentSummary {
  export type Model = UserContentSummaryModel
  export const Key = 'user-content-summary'
}
